import type { JSX, Ref } from 'react';

import { ChevronRightIcon, type ScaleIcon } from '../../../shell/icons.js';

const cardClasses =
  'flex w-full items-center gap-stock-5 rounded-lg border-2 border-wizard-card-border bg-card text-left ' +
  'transition-colors hover:border-primary/50 ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ring';
const iconClasses = 'h-6 w-6 shrink-0 text-primary sm:h-9 sm:w-9';
const arrowClasses = 'h-5 w-5 shrink-0 text-wizard-card-chevron sm:h-7 sm:w-7';

export interface ContactChoiceCardProps {
  readonly title: string;
  readonly description?: string;
  readonly icon: typeof ScaleIcon;
  readonly onClick: () => void;
  readonly ref?: Ref<HTMLButtonElement> | undefined;
}

/** Channel and service cards share the prototype's plain glyph and trailing arrow. */
export function ContactChoiceCard({
  title,
  description,
  icon: Icon,
  onClick,
  ref,
}: ContactChoiceCardProps): JSX.Element {
  const channel = description === undefined;
  return (
    <button
      ref={ref}
      type="button"
      className={`${cardClasses} ${channel ? 'min-h-wizard-channel-card p-5 sm:p-7' : 'min-h-wizard-service-card p-4 sm:p-7'}`}
      onClick={onClick}
    >
      <Icon aria-hidden="true" className={iconClasses} />
      <span className="min-w-0 flex-1 break-words">
        <span
          className={
            channel
              ? 'block text-xl font-semibold sm:text-2xl'
              : 'block text-base font-semibold sm:text-xl'
          }
        >
          {title}
        </span>
        {description !== undefined ? (
          <span className="block text-sm text-foreground sm:text-base">{description}</span>
        ) : null}
      </span>
      <ChevronRightIcon aria-hidden="true" className={arrowClasses} />
    </button>
  );
}
